import React from "react";
import styled from "styled-components"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ";
import { Title } from "@airasia/phoenix-components/components";
import _ from "lodash";
import Showdown from "showdown";

const mdConverter = new Showdown.Converter()


const Container = styled.div`
    width: 100%;
    margin-block: 20px;
    // border: 1px solid red;
`;

const formatText = (text, keywords) => {
    let newText = text;
    for(const keyword in keywords){
        newText = newText.replace(`{{${keyword}}}`, keywords[keyword]);
    }
    return newText;
}

const FaqAccordion = ({title="Frequestly Asked Questions", question_list=[], keywords = {}}) => {

    const properizeList = (list) => {
        let temp;
        if(_.isArray(list)){
            temp = list.map(x => {
                return({question: formatText(x.question, keywords), answer: `${mdConverter.makeHtml(formatText(x.answer, keywords))}`})
            })
        }
        return temp;
    }

    return (
        <Container>
            <Title type="h2">{title}</Title>
            <FAQ
                data={properizeList(question_list)}
                keywords={keywords}
                displayIndex={false}
                size={{}}
                theme="AIRASIA_MOVE"
                titleMarginBottom="normal"
                titleType="h3"
            />
        </Container>
    )
}

export default FaqAccordion;